const l = [
  {
    name: "Streaming Devices",
    slug: "streaming-devices"
  },
  [
    {
      id: 1,
      image_url: "https://iontelevision.com/static/global/samsung-tv-plus-logo.png",
      alt_text: "Samsung Plus TV",
      link: "#"
    },
    {
      id: 2,
      image_url: "https://iontelevision.com/static/global/tlc-logo.jpeg",
      alt_text: "TLC Channel",
      link: "#"
    },
    {
      id: 3,
      image_url: "https://iontelevision.com/static/global/roku-logo.png",
      alt_text: "Roku Channel",
      link: "#"
    },
    {
      id: 4,
      image_url: "https://iontelevision.com/static/global/vizio-watch-free-logo.png",
      alt_text: "Vizio Watch Free +",
      link: "#"
    }
  ]
], a = [
  {
    name: "Smart TVs",
    slug: "smart-tvs"
  },
  [
    {
      id: 5,
      image_url: "https://iontelevision.com/static/global/samsung-tv-plus-logo.png",
      alt_text: "Samsung Plus TV",
      link: "#"
    },
    {
      id: 6,
      image_url: "https://iontelevision.com/static/global/tlc-logo.jpeg",
      alt_text: "TLC Channel",
      link: "#"
    },
    {
      id: 7,
      image_url: "https://iontelevision.com/static/global/roku-logo.png",
      alt_text: "Roku Channel",
      link: "#"
    },
    {
      id: 8,
      image_url: "https://iontelevision.com/static/global/vizio-watch-free-logo.png",
      alt_text: "Vizio Watch Free +",
      link: "#"
    },
    {
      id: 9,
      image_url: "https://iontelevision.com/static/global/samsung-tv-plus-logo.png",
      alt_text: "Samsung Plus TV",
      link: "#"
    },
    {
      id: 10,
      image_url: "https://iontelevision.com/static/global/tlc-logo.jpeg",
      alt_text: "TLC Channel",
      link: "#"
    },
    {
      id: 11,
      image_url: "https://iontelevision.com/static/global/roku-logo.png",
      alt_text: "Roku Channel",
      link: "#"
    }
  ]
], e = [
  {
    name: "Audio Platforms",
    slug: "audio-platforms"
  },
  [
    {
      id: 12,
      image_url: "https://iontelevision.com/static/global/samsung-tv-plus-logo.png",
      alt_text: "Samsung Plus TV",
      link: "#"
    },
    {
      id: 13,
      image_url: "https://iontelevision.com/static/global/tlc-logo.jpeg",
      alt_text: "TLC Channel",
      link: "#"
    },
    {
      id: 14,
      image_url: "https://iontelevision.com/static/global/roku-logo.png",
      alt_text: "Roku Channel",
      link: "#"
    }
  ]
], t = [
  {
    name: "Video Platforms",
    slug: "video-platforms"
  },
  [
    {
      id: 15,
      image_url: "https://iontelevision.com/static/global/samsung-tv-plus-logo.png",
      alt_text: "Samsung Plus TV",
      link: "#"
    },
    {
      id: 16,
      image_url: "https://iontelevision.com/static/global/tlc-logo.jpeg",
      alt_text: "TLC Channel",
      link: "#"
    },
    {
      id: 17,
      image_url: "https://iontelevision.com/static/global/roku-logo.png",
      alt_text: "Roku Channel",
      link: "#"
    },
    {
      id: 18,
      image_url: "https://iontelevision.com/static/global/vizio-watch-free-logo.png",
      alt_text: "Vizio Watch Free +",
      link: "#"
    },
    {
      id: 19,
      image_url: "https://iontelevision.com/static/global/samsung-tv-plus-logo.png",
      alt_text: "Samsung Plus TV",
      link: "#"
    },
    {
      id: 20,
      image_url: "https://iontelevision.com/static/global/tlc-logo.jpeg",
      alt_text: "TLC Channel",
      link: "#"
    },
    {
      id: 21,
      image_url: "https://iontelevision.com/static/global/roku-logo.png",
      alt_text: "Roku Channel",
      link: "#"
    },
    {
      id: 22,
      image_url: "https://iontelevision.com/static/global/vizio-watch-free-logo.png",
      alt_text: "Vizio Watch Free +",
      link: "#"
    },
    {
      id: 23,
      image_url: "https://iontelevision.com/static/global/samsung-tv-plus-logo.png",
      alt_text: "Samsung Plus TV",
      link: "#"
    },
    {
      id: 24,
      image_url: "https://iontelevision.com/static/global/tlc-logo.jpeg",
      alt_text: "TLC Channel",
      link: "#"
    },
    {
      id: 25,
      image_url: "https://iontelevision.com/static/global/roku-logo.png",
      alt_text: "Roku Channel",
      link: "#"
    },
    {
      id: 26,
      image_url: "https://iontelevision.com/static/global/vizio-watch-free-logo.png",
      alt_text: "Vizio Watch Free +",
      link: "#"
    },
    {
      id: 27,
      image_url: "https://iontelevision.com/static/global/samsung-tv-plus-logo.png",
      alt_text: "Samsung Plus TV",
      link: "#"
    },
    {
      id: 28,
      image_url: "https://iontelevision.com/static/global/tlc-logo.jpeg",
      alt_text: "TLC Channel",
      link: "#"
    }
  ]
], o = [
  {
    name: "Mobile Devices",
    slug: "mobile-devices"
  },
  [
    {
      id: 29,
      image_url: "https://iontelevision.com/static/global/samsung-tv-plus-logo.png",
      alt_text: "Samsung Plus TV",
      link: "#"
    },
    {
      id: 30,
      image_url: "https://iontelevision.com/static/global/tlc-logo.jpeg",
      alt_text: "TLC Channel",
      link: "#"
    }
  ]
], i = /* @__PURE__ */ new Map([
  [l[0], [...l[1]]],
  [a[0], [...a[1]]],
  [e[0], [...e[1]]],
  [t[0], [...t[1]]],
  [o[0], [...o[1]]]
]), n = /* @__PURE__ */ new Map([
  [t[0], [...t[1]]],
  [l[0], [...l[1]]],
  [a[0], [...a[1]]],
  [e[0], [...e[1]]],
  [o[0], [...o[1]]]
]), s = /* @__PURE__ */ new Map([
  [l[0], [...l[1]]],
  [a[0], [...a[1]]],
  [e[0], [...e[1]]]
]), u = {
  network: "Court TV",
  platform: [
    {
      order: 0,
      category_title: "STREAMING DEVICES",
      logos: [
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/3e462879-roku_ctv-where-to-watch-page-logos_456x322.png",
          order: 0,
          app_url: "https://channelstore.roku.com/details/288753/court-tv",
          alt_text: "Roku"
        },
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/7cef63d1-amazon-fire-tv_ctv-where-to-watch-page-logos_456x322.png",
          order: 1,
          app_url: "https://www.amazon.com/Katz-Broadcasting-LLC-Court-TV/dp/B07RGS15ZS",
          alt_text: "Fire TV"
        },
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/e698f674-apple-tv_ctv-where-to-watch-page-logos_456x322-1.png",
          order: 2,
          app_url: "https://apps.apple.com/us/app/court-tv/id1458511072#?platform=appleTV",
          alt_text: "Apple TV"
        },
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/a23e5ffe-android-tv_ctv-where-to-watch-page-logos_456x322.png",
          order: 3,
          app_url: "https://www.android.com/tv/",
          alt_text: ""
        }
      ]
    },
    {
      order: 1,
      category_title: "VIDEO PLATFORMS",
      logos: [
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/04/80fcb209-samsungtvplus_where-to-watch-logo_456x322.png",
          order: 0,
          app_url: "https://www.samsung.com/us/televisions-home-theater/tvs/tvplus/",
          alt_text: ""
        },
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/af349b7e-pluto-tv_ctv-where-to-watch-page-logos_456x322.png",
          order: 1,
          app_url: "https://pluto.tv/welcome",
          alt_text: ""
        },
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/dcf2574f-youtube-tv_ctv-where-to-watch-page-logos_456x322.png",
          order: 2,
          app_url: "https://tv.youtube.com/welcome/",
          alt_text: ""
        },
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/39cb5b9b-xumo_ctv-where-to-watch-page-logos_456x322.png",
          order: 3,
          app_url: "https://www.xumo.tv/on-now/99991713/court-tv",
          alt_text: ""
        },
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/c596d00c-free-cast_ctv-where-to-watch-page-logos_456x322.png",
          order: 4,
          app_url: "https://urldefense.proofpoint.com/v2/url?u=https-3A__itunes.apple.com_us_app_court-2Dtv_id1458511072&d=DwIGaQ&c=aLv4kG3eFBuAUFgZFQ07JQ&r=EnXbu3updRErvhVaSLaq08hYAYsdVowJZw7FTkuL7Ic&m=dgVpsR9sTriezIvxuh50VmlbMvdiEJPnNv-c8x8duFQ&s=p0t0-DwySfywV8XBx6On-n0J6U49Ixrqx6sWZhHyh04&e=",
          alt_text: ""
        },
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/b20b2966-freecast_ctv-where-to-watch-page-logos_456x322.png",
          order: 5,
          app_url: "https://www.selecttv.com/",
          alt_text: ""
        },
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/a355cc40-nkt.tv_ctv-where-to-watch-page-logos_456x322.png",
          order: 6,
          app_url: "https://nkt.tv/",
          alt_text: ""
        },
        {
          logo_url: "https://storage.googleapis.com/www-courttv-uploads/2021/01/9a121d42-redbox_ctv-where-to-watch-page-logos_456x322.png",
          order: 7,
          app_url: "https://www.redbox.com/stream-free-live-tv?channel=court_tv",
          alt_text: ""
        }
      ]
    }
  ]
}, r = [
  { label: "Alabama", value: "al" },
  { label: "Alaska", value: "ak" },
  { label: "Arizona", value: "az" },
  { label: "Arkansas", value: "ar" },
  { label: "California", value: "ca" },
  { label: "Colorado", value: "co" },
  { label: "Connecticut", value: "ct" },
  { label: "Delaware", value: "de" },
  { label: "District Of Columbia", value: "dc" },
  { label: "Florida", value: "fl" },
  { label: "Georgia", value: "ga" },
  { label: "Hawaii", value: "hi" },
  { label: "Idaho", value: "id" },
  { label: "Illinois", value: "il" },
  { label: "Indiana", value: "in" },
  { label: "Iowa", value: "ia" },
  { label: "Kansas", value: "ks" },
  { label: "Kentucky", value: "ky" },
  { label: "Louisiana", value: "la" },
  { label: "Maine", value: "me" },
  { label: "Maryland", value: "md" },
  { label: "Massachusetts", value: "ma" },
  { label: "Michigan", value: "mi" },
  { label: "Minnesota", value: "mn" },
  { label: "Mississippi", value: "ms" },
  { label: "Missouri", value: "mo" },
  { label: "Montana", value: "mt" },
  { label: "Nebraska", value: "ne" },
  { label: "Nevada", value: "nv" },
  { label: "New Hampshire", value: "nh" },
  { label: "New Jersey", value: "nj" },
  { label: "New Mexico", value: "nm" },
  { label: "New York", value: "ny" },
  { label: "North Carolina", value: "nc" },
  { label: "North Dakota", value: "nd" },
  { label: "Ohio", value: "oh" },
  { label: "Oklahoma", value: "ok" },
  { label: "Oregon", value: "or" },
  { label: "Pennsylvania", value: "pa" },
  { label: "Rhode Island", value: "ri" },
  { label: "South Carolina", value: "sc" },
  { label: "South Dakota", value: "sd" },
  { label: "Tennessee", value: "tn" },
  { label: "Texas", value: "tx" },
  { label: "Utah", value: "ut" },
  { label: "Vermont", value: "vt" },
  { label: "Virginia", value: "va" },
  { label: "Washington", value: "wa" },
  { label: "West Virginia", value: "wv" },
  { label: "Wisconsin", value: "wi" },
  { label: "Wyoming", value: "wy" }
], p = [
  {
    parent_id: null,
    label: "Alabama",
    value: "al",
    id: 1
  },
  {
    parent_id: null,
    label: "Alaska",
    value: "ak",
    id: 2
  },
  {
    parent_id: null,
    label: "Arizona",
    value: "az",
    id: 3
  },
  {
    parent_id: null,
    label: "Arkansas",
    value: "ar",
    id: 4
  },
  {
    parent_id: null,
    label: "California",
    value: "ca",
    id: 5
  },
  {
    parent_id: null,
    label: "Colorado",
    value: "co",
    id: 6
  },
  {
    parent_id: null,
    label: "Connecticut",
    value: "ct",
    id: 7
  },
  {
    parent_id: null,
    label: "Delaware",
    value: "de",
    id: 8
  },
  {
    parent_id: null,
    label: "District Of Columbia",
    value: "dc",
    id: 10
  },
  {
    parent_id: null,
    label: "Florida",
    value: "fl",
    id: 11
  },
  {
    parent_id: null,
    label: "Georgia",
    value: "ga",
    id: 12
  },
  {
    parent_id: null,
    label: "Hawaii",
    value: "hi",
    id: 13
  },
  {
    parent_id: null,
    label: "Idaho",
    value: "id",
    id: 14
  },
  {
    parent_id: null,
    label: "Illinois",
    value: "il",
    id: 15
  },
  {
    parent_id: null,
    label: "Indiana",
    value: "in",
    id: 16
  },
  {
    parent_id: null,
    label: "Iowa",
    value: "ia",
    id: 17
  },
  {
    parent_id: null,
    label: "Kansas",
    value: "ks",
    id: 18
  },
  {
    parent_id: null,
    label: "Kentucky",
    value: "ky",
    id: 19
  },
  {
    parent_id: null,
    label: "Louisiana",
    value: "la",
    id: 20
  },
  {
    parent_id: null,
    label: "Maine",
    value: "me",
    id: 21
  },
  {
    parent_id: null,
    label: "Maryland",
    value: "md",
    id: 22
  },
  {
    parent_id: null,
    label: "Massachusetts",
    value: "ma",
    id: 23
  },
  {
    parent_id: null,
    label: "Michigan",
    value: "mi",
    id: 24
  },
  {
    parent_id: null,
    label: "Minnesota",
    value: "mn",
    id: 25
  },
  {
    parent_id: null,
    label: "Mississippi",
    value: "ms",
    id: 26
  },
  {
    parent_id: null,
    label: "Missouri",
    value: "mo",
    id: 27
  },
  {
    parent_id: null,
    label: "Montana",
    value: "mt",
    id: 28
  },
  {
    parent_id: null,
    label: "Nebraska",
    value: "ne",
    id: 29
  },
  {
    parent_id: null,
    label: "Nevada",
    value: "nv",
    id: 30
  },
  {
    parent_id: null,
    label: "New Hampshire",
    value: "nh",
    id: 31
  },
  {
    parent_id: null,
    label: "New Jersey",
    value: "nj",
    id: 32
  },
  {
    parent_id: null,
    label: "New Mexico",
    value: "nm",
    id: 33
  },
  {
    parent_id: null,
    label: "New York",
    value: "ny",
    id: 34
  },
  {
    parent_id: null,
    label: "North Carolina",
    value: "nc",
    id: 35
  },
  {
    parent_id: null,
    label: "North Dakota",
    value: "nd",
    id: 36
  },
  {
    parent_id: null,
    label: "Ohio",
    value: "oh",
    id: 37
  },
  {
    parent_id: null,
    label: "Oklahoma",
    value: "ok",
    id: 38
  },
  {
    parent_id: null,
    label: "Oregon",
    value: "or",
    id: 39
  },
  {
    parent_id: null,
    label: "Pennsylvania",
    value: "pa",
    id: 40
  },
  {
    parent_id: null,
    label: "Rhode Island",
    value: "ri",
    id: 41
  },
  {
    parent_id: null,
    label: "South Carolina",
    value: "sc",
    id: 42
  },
  {
    parent_id: null,
    label: "South Dakota",
    value: "sd",
    id: 43
  },
  {
    parent_id: null,
    label: "Tennessee",
    value: "tn",
    id: 44
  },
  {
    parent_id: null,
    label: "Texas",
    value: "tx",
    id: 45
  },
  {
    parent_id: null,
    label: "Utah",
    value: "ut",
    id: 46
  },
  {
    parent_id: null,
    label: "Vermont",
    value: "vt",
    id: 47
  },
  {
    parent_id: null,
    label: "Virginia",
    value: "va",
    id: 48
  },
  {
    parent_id: null,
    label: "Washington",
    value: "wa",
    id: 49
  },
  {
    parent_id: null,
    label: "West Virginia",
    value: "wv",
    id: 50
  },
  {
    parent_id: null,
    label: "Wisconsin",
    value: "wi",
    id: 51
  },
  {
    parent_id: null,
    label: "Wyoming",
    value: "wy",
    id: 52
  }
];
export {
  e as audio_platforms,
  o as mobile_devices,
  i as platform_resources,
  n as platform_resources_video_platforms_first,
  s as small_platform_resouces,
  a as smart_tvs,
  r as stateOptions,
  p as statesForCustomList,
  l as streaming_devices,
  t as video_platforms,
  u as wp_platform_resources
};
